import { z } from 'zod';

const jsonLiteralSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export type JsonValue =
  | z.infer<typeof jsonLiteralSchema>
  | JsonValue[]
  | { [key: string]: JsonValue };

export const jsonSchema: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([
    jsonLiteralSchema,
    z.array(jsonSchema),
    z.record(z.string(), jsonSchema),
  ])
);
